import { render } from "./CampaignSummary.vue?vue&type=template&id=2efd40dd"
import script from "./CampaignSummary.vue?vue&type=script&lang=js"
export * from "./CampaignSummary.vue?vue&type=script&lang=js"
script.render = render

export default script